import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import { pageMeta } from "@/lib/seo/meta";
import { TOOL_CACHE_HEADERS } from "@/lib/seo/headers";

const OrganizePdfView = lazy(() => import("@/features/organize-pdf/view"));

export const Route = createFileRoute("/organize-pdf")({
  head: () =>
    pageMeta({
      title: "Organize PDF pages",
      description: "Drag pages into the order you want. Rotate or delete them while you're at it.",
      path: "/organize-pdf",
      keywords: "reorder pdf pages, organize pdf, rearrange pdf, online, free",
    }),
  headers: () => TOOL_CACHE_HEADERS,
  component: () => (
    <Suspense fallback={null}>
      <OrganizePdfView />
    </Suspense>
  ),
});
